import $ from 'jquery';

/**
 * Custom form plugin
 */
export default class TreasurybondsForm {
    /**
     * @param $form Custom form
     * @param options Additional options
     */
    constructor($form, options = {}) {
        this.options = $.extend(true, {
            classes: {
                type: 'id_type_bonds',
                issue: 'id_issue_bonds',
                period: 'id_interest_table_bonds',
                submit: 'btn-submit',
                clear: 'btn--clear'
            },
        },
            this.state = {
                isLoading: false, // true if any loading is on page
            },
            options);

        if (!$form) {
            return;
        }

        this.$form = $form;
        this.$formId = this.$form.id;

        this.$type = this.$form.querySelector('#' + this.options.classes.type);
        this.$issue = this.$form.querySelector('#' + this.options.classes.issue);
        this.$period = this.$form.querySelector('#' + this.options.classes.period);

        this.$issueWrapper = this.$form.querySelector('.wrap-' + this.options.classes.issue);
        this.$issueInner = this.$issueWrapper.querySelector('.choices__list--single');

        if (this.$formId === 'interest-bonds') {
            this.$periodWrapper = this.$form.querySelector('.wrap-' + this.options.classes.period);
            this.$periodInner = this.$periodWrapper.querySelector('.choices__list--single');
        }

        if (this.$formId === 'issue-letter' || this.$formId === 'issue-letter-archive') {
            this.$clear = this.$form.querySelector('.' + this.options.classes.clear);
        }

        this.$submit = this.$form.querySelector('.' + this.options.classes.submit);

        this.init();
    }

    //initialization functions

    init() {
        if (this.$formId === 'interest-bonds') this.initInterestBonds();
        if (this.$formId === 'archived-products') this.initArchivedProducts();
        if (this.$formId === 'issue-letter') this.initIssueLetter();
        if (this.$formId === 'issue-letter-archive') this.initArchivedIssueLetter();

        this.handleToggle(this.$form);
    }

    initInterestBonds() {
        const id = new URLSearchParams(window.location.search).get('table_id');

        this.selectIssueChange();
        this.selectPeriodChange();

        this.$periodInner.querySelector('.choices__item').classList.remove('choices__item--hidden');

        if (id !== null) {
            const activeItem = this.$periodWrapper.querySelector(".choices__item[data-value*='" + id + ",']");
            this.$periodInner.querySelector('.choices__item').innerText = activeItem.textContent;
        }
    }

    initArchivedProducts() {
        this.selectTypeChange();
    }

    initIssueLetter() {
        const id = new URLSearchParams(window.location.search).get('id');
        const select = this.$issueWrapper.querySelector(".choices__item[data-value*='?id=" + this.$type.value + "']");

        this.selectTypeChange(false);

        this.$issueInner.querySelector('.choices__item').classList.remove('choices__item--hidden');
        if (id) {
            const activeItem = this.$issueWrapper.querySelector(".choices__item[data-value*='" + id + ",']");
            this.$issueInner.querySelector('.choices__item').innerText = activeItem.textContent;
        } else if (select) {
            this.$issueInner.querySelector('.choices__item').innerText = select.textContent;
        } else {
            this.resetIssueValue();
        }
    }

    initArchivedIssueLetter() {
        const id = new URLSearchParams(window.location.search).get('id');

        this.selectTypeChange(false);

        this.$issueInner.querySelector('.choices__item').classList.remove('choices__item--hidden');
        if (id) {
            const activeItem = this.$issueWrapper.querySelector(".choices__item[data-value*='" + id + ",']");
            this.$issueInner.querySelector('.choices__item').innerText = activeItem.textContent;
        } else {
            this.resetIssueValue();
        }
    }

    //functions called on select change

    selectTypeChange(initial) {
        if (this.$type.value !== '0') {
            if (this.$formId === 'interest-bonds') {
                this.toggleFilterLoader(true);
                window.location.replace('?product=' + this.$type.value);
            } else {
                this.$issueWrapper.querySelectorAll('.choices__item').forEach((item) => {
                    const parentValue = this.$type.value.split(',');
                    const itemValue = item.getAttribute('data-value').split(',');
                    if (parentValue[0] !== itemValue[1]) {
                        item.classList.add('choices__item--hidden');
                    } else {
                        item.classList.remove('choices__item--hidden');
                    }
                });
            }

            if (this.$formId === 'issue-letter') {
                if (initial) this.resetIssueValue();
            } else {
                this.resetIssueValue();
            }
        }
    }

    selectIssueChange() {
        this.$issueWrapper.querySelectorAll('.choices__item').forEach((item) => {
            const itemValue = item.getAttribute('data-value').split(",");

            if (this.$formId === 'interest-bonds') {
                if (this.$type.value !== itemValue[1]) item.remove();
            } else {
                const parentValue = this.$type.value.split(',');
                if (parentValue[0] !== itemValue[1]) {
                    item.classList.add('choices__item--hidden');
                } else {
                    item.classList.remove('choices__item--hidden');
                }
            }
        });

        if (this.$formId === 'interest-bonds') {
            this.selectPeriodChange();
            this.resetPeriodValue();
        }
    }

    selectPeriodChange() {
        this.$periodWrapper.querySelectorAll('.choices__item').forEach((item) => {
            const parentValue = this.$issue.value.split(',');
            const itemValue = item.getAttribute('data-value').split(',');

            if (parentValue[0] !== itemValue[1]) {
                item.classList.add('choices__item--hidden');
            } else {
                item.classList.remove('choices__item--hidden');
            }
        });
    }

    //reset select value if parent value changes

    resetPeriodValue() {
        this.$period.value = '';
        this.$periodInner.querySelector('.choices__item').classList.remove('choices__item--hidden');
        this.$periodInner.querySelector('.choices__item').innerText = "Okres odsetkowy";
    }

    resetIssueValue() {
        this.$issue.value = '';
        this.$issueWrapper.querySelector('.choices__item').classList.remove('choices__item--hidden');
        this.$issueWrapper.querySelector('.choices__item').innerText = "Emisja";
    }

    //submit form functions

    submitInterestBonds() {
        if (this.$period.value.split(',')[0] !== '0' && this.$period.value.split(',')[0] !== '') {
            const id = this.$period.value === '' ? new URLSearchParams(window.location.search).get('table_id') : this.$period.value.split(',')[0];
            this.toggleFilterLoader(true);
            window.location.assign(window.location.pathname + '?table_id=' + id);
        }
    }

    submitArchivedProducts() {
        const value = this.$issue.value.split(',');

        if (value[0] !== '') {
            this.toggleFilterLoader(true);

            let currentPath = window.location.pathname.split('/');
            currentPath = currentPath[currentPath.length - 2];
            const newPath = window.location.pathname.replace('/' + currentPath + '/', '');
            window.location.assign(newPath + value[0]);
        }
    }

    submitIssueLetter() {
        const value = this.$issue.value.split(',');
        const id = value[0].split('/');

        if (value[0] !== '') {
            this.toggleFilterLoader(true);
            window.location.assign(window.location.pathname + id[2]);
        }
    }

    submitArchivedIssueLetter() {
        const value = this.$issue.value.split(',');
        const id = value[0].split('/');

        if (value[0] !== '') {
            this.toggleFilterLoader(true);
            window.location.assign(window.location.pathname + id[2]);
        }
    }

    //loader function

    toggleFilterLoader(state) {
        this.state.isLoading = state;
        const filterBlock = this.$form.closest('.filter-block');
        filterBlock.classList.toggle('filter-block--loading', state);

        if (state) {
            filterBlock.insertAdjacentHTML('beforeend', '<div class="loader"></div>')
        } else {
            if (filterBlock.querySelector('.loader')) {
                filterBlock.querySelector('.loader').remove();
            }
        }
    }

    //reset form and refresh page

    clearButton() {
        this.toggleFilterLoader(true);
        window.location.assign(window.location.pathname);
    }

    handleToggle() {
        const submitHandler = (e) => {
            e.preventDefault();

            if (this.$formId === 'interest-bonds') this.submitInterestBonds();
            if (this.$formId === 'archived-products') this.submitArchivedProducts();
            if (this.$formId === 'issue-letter') this.submitIssueLetter();
            if (this.$formId === 'issue-letter-archive') this.submitArchivedIssueLetter();
        }

        this.$submit.addEventListener('click', submitHandler);
        this.$type.addEventListener('change', this.selectTypeChange.bind(this));
        this.$issue.addEventListener('change', this.selectIssueChange.bind(this));

        if (this.$formId === 'interest-bonds') this.$period.addEventListener('change', this.selectPeriodChange.bind(this));
        if (this.$formId === 'issue-letter') this.$clear.addEventListener('click', this.clearButton.bind(this));
        if (this.$formId === 'issue-letter-archive') this.$clear.addEventListener('click', this.clearButton.bind(this));

        window.addEventListener('pageshow', () => this.toggleFilterLoader(false));
    }
}


// WEBPACK FOOTER //
// ./front/treasurybond/js/common/treasurybonds-form.js